import { number, object, string } from 'yup';

export const giftCardSchema = object().shape({
    planId: number().min(1).required(),
    codeType: string().oneOf(['random', 'defined']).required(),
    code: string().when('codeType', {
        is: (codeType: string) => codeType === 'defined',
        then: (schema) => schema.min(4).required(),
        otherwise: (schema) => schema.optional(),
    }),
});
